import { useMapStore } from "stores/map";

export function useUpdateLabelTextSize() {
  const setDisplaySettings = useMapStore((s) => s.setDisplaySettings);

  // Functional updaters (EVA-63) — avoid spreading a stale render-time
  // `displaySettings` snapshot over a concurrently-applied View restore.
  const updateWellLabelTextSize = (textSize: number) => {
    setDisplaySettings((current) => ({ ...current, wellLabelSize: textSize }));
  };

  const updateFacilityLabelTextSize = (textSize: number) => {
    setDisplaySettings((current) => ({ ...current, facilityLabelSize: textSize }));
  };

  const updateShapefileDetailLabelTextSize = (textSize: number) => {
    setDisplaySettings((current) => ({
      ...current,
      shapefileDetailsLabelSize: textSize
    }));
  };

  const updateShapefileNameLabelTextSize = (textSize: number) => {
    setDisplaySettings((current) => ({ ...current, shapefileNameLabelSize: textSize }));
  };

  const updateSectionLabelTextSize = (textSize: number) => {
    setDisplaySettings((current) => ({ ...current, sectionLabelSize: textSize }));
  };

  // The US/Texas grid labels are sized one layer at a time, so this one keeps a
  // record keyed by layerId instead of a single size.
  const updateGridLabelTextSize = (layerId: string, textSize: number) => {
    setDisplaySettings((current) => ({
      ...current,
      gridLabelSizes: { ...current.gridLabelSizes, [layerId]: textSize }
    }));
  };

  return {
    updateWellLabelTextSize,
    updateFacilityLabelTextSize,
    updateShapefileDetailLabelTextSize,
    updateShapefileNameLabelTextSize,
    updateSectionLabelTextSize,
    updateGridLabelTextSize
  };
}
